import { render, staticRenderFns } from "./TiktokProductSync.vue?vue&type=template&id=9780fb02&scoped=true"
import script from "./TiktokProductSync.vue?vue&type=script&lang=js"
export * from "./TiktokProductSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9780fb02",
  null
  
)

export default component.exports